import styled from '@emotion/styled';
import {
// Import anything you need from styled-system
} from 'styled-system';

const CharCounter = styled('div')`
  color: ${(props) => (props.isNearLimit ? '#C0392B' : '#666666')};
  font-family: "Nunito Sans";
  font-size: 10px;
  margin-top: 4px;
  text-align: right;
  width: 100%;
`;

export default CharCounter;
